import { Stack, styled } from '@mui/material';

export const Wrapper = styled(Stack)(() => ({
  flexDirection: 'row',
  gap: 'var(--spacing-small)',
}));
